import React from "react"
import ReactDOMServer from "react-dom/server"

const JsonLd = ({ json }) => {
  const { id, ...schema } = json
  // https://dev.to/aviaryan/rendering-json-ld-data-in-nextjs-and-reactjs-29op
  return (
    <script
      key={`JSON-${ReactDOMServer.renderToString(id)
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/[\s_-]+/g, "-")
        .replace(/^-+|-+$/g, "")}`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  )
}

export default JsonLd
